export default "__VITE_ASSET__CmwcKPh___"